// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import { sync } from 'vuex-router-sync'
import VueI18n from 'vue-i18n'

import { Loading } from 'element-ui'

import router from './router'
import store from './store'
import App from './App'

import locales from './lang'

import './theme/index.css'
import './helper.css'

// store synchronization
sync(store, router)

Vue.use(Loading)
Vue.use(VueI18n)

// i18n / internationalization
const i18n = new VueI18n({
  locale: window.localStorage.language || 'fr_FR',
  messages: locales
})

Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  router,
  store,
  i18n,
  template: '<App/>',
  components: { App }
}).$mount('#app')



// WEBPACK FOOTER //
// ./src/main.js